import React from 'react'
import { Container } from 'react-angle-dashboard-components'
import styled from 'styled-components'

export const LayoutContainer: React.FC = ({ children }) => (
  <StyledContainer fluid>{children}</StyledContainer>
)

const StyledContainer = styled(Container)`
  max-width: 1200px;
  padding: 0px;
  @media screen and (max-width: 420px) {
    padding: 0px 1.3em !important;
  }
`
